import { useSelector } from "react-redux";
import { useConectividadApi } from "./service";

export const useComisionService = () => {
    const { serverData } = useConectividadApi();
    const session = useSelector(state => state.session);

    /**
   * @methodApi get.
   * @description  Método encargado de obtener una lista de comisiones
   */
    const get = async () => {
        try {
            const options = {
                method: 'GET',
                url: '/comisiones',
                headers: {
                    Authorization: `Bearer ${session.credentials.accessToken}`
                }
            };
            return await serverData(options).then(response => {
                let data = response;
                if (data) {
                    return data;
                }
            });
        } catch (err) {
            console.error(err);
        }
    }

    /**
    * @methodApi v.
    * @description  Método encargado de obtener comision por Id
    */
    const getId = async (comisionId) => {
        try {
            const options = {
                method: 'GET',
                url: `/comisiones/${comisionId}`,
                headers: {
                    Authorization: `Bearer ${session.credentials.accessToken}`
                }
            };
            return await serverData(options).then(response => {
                let data = response;
                if (data) {
                    return data;
                }
            });
        } catch (err) {
            console.error(err);
        }
    }

    /**
* @methodApi post.
* @description  Método encargado de crear comisiones
*/
    const post = async (values) => {
        try {
            const options = {
                method: 'POST',
                url: '/comisiones',
                headers: {
                    Authorization: `Bearer ${session.credentials.accessToken}`
                },
                data: values
            };
            try {
                await serverData(options);
            } catch (error) {
                let { data } = error;
                alert(data.msg);
            }
        } catch (error) {
            let { data } = error;
            alert(data.msg);
        }
    }
    /**
    * @methodApi v.
    * @description  Método encargado de actualizar comisiones
    */
    const put = async (comisionId, values) => {
        try {
            const options = {
                method: 'PUT',
                url: `/comisiones/${comisionId}`,
                headers: {
                    Authorization: `Bearer ${session.credentials.accessToken}`
                },
                data: values
            };
            try {
                await serverData(options);
            } catch (error) {
                let { data } = error;
                alert(data.msg);
            }
        } catch (error) {
            let { data } = error;
            alert(data.msg);
        }
    }

    /**
* @methodApi v.
* @description  Método encargado de eliminar comisiones
*/
    const patch = async (comisionId) => {
        try {
            const options = {
                method: 'PATCH',
                url: `/comisiones/${comisionId}`,
                headers: {
                    Authorization: `Bearer ${session.credentials.accessToken}`
                },
            };
            try {
                await serverData(options);
            } catch (error) {
                let { data } = error;
                alert(data.msg);
            }
        } catch (error) {
            let { data } = error;
            alert(data.msg);
        }
    }
    return {
        //Api Comisiones
        get,
        post,
        put,
        patch,
    }

}